var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadSectionImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 370,
    viewBox: "0 0 508 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404.713 314.866L301.904 369L192.941 308.946L294.061 260.672L404.713 314.866Z",
    fill: "url(#paint0_linear_734_22644)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M393.612 212.157L360.67 138.449V133.555L395.724 213.305L393.612 212.157Z",
    fill: "#F25C3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360.488 139.174L332.493 212.822L330.562 213.849L360.488 133.736V139.174Z",
    fill: "#F25C3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.92 250.945C259.31 243.393 297.32 254.147 310.232 275.112C323.143 296.077 305.345 318.854 270.955 326.406C236.564 333.958 198.554 323.204 185.643 302.239C172.731 281.274 190.53 258.437 224.92 250.945Z",
    fill: "#E29F00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M410 233.787C409.638 281.697 324.508 290.941 317.207 236.203C315.035 197.114 408.673 195.361 410 233.787Z",
    fill: "#F5AC00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M408.674 232.82C409.338 242.728 401.494 250.945 390.151 255.778C373.164 262.973 354.038 263.211 336.877 256.443C330.048 253.614 324.211 248.82 320.104 242.668C303.331 206.841 397.271 189.924 408.674 232.82Z",
    fill: "#FFC233"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M391.055 250.764C391.19 252.486 390.878 254.213 390.15 255.778C373.163 262.973 354.036 263.211 336.876 256.443C326.74 235.358 384.117 225.328 391.055 250.764Z",
    fill: "#5E3911"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M360.186 139.838L328.511 251.851L327.184 250.824L360.186 133.374V139.838Z",
    fill: "#F25C3E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M398.922 250.401L397.654 251.368L361.213 139.717V134.038L361.575 135.367L398.922 250.401Z",
    fill: "#F25C3E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M174.962 93.1359L142.02 19.3667V14.5334L177.013 94.2234L174.962 93.1359Z",
    fill: "#F25C3E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M141.838 20.1522L113.783 93.7401L111.853 94.7672L141.838 14.6542V20.1522Z",
    fill: "#F25C3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.83 114.705C190.83 162.676 105.398 171.859 98.0372 117.121C95.8652 78.0317 189.563 76.2796 190.83 114.705Z",
    fill: "#F5AC00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.562 113.799C190.226 123.646 182.443 131.924 171.04 136.697C154.053 143.891 134.926 144.13 117.765 137.361C110.908 134.49 105.067 129.629 100.992 123.405C84.2197 87.7588 178.22 70.842 189.562 113.799Z",
    fill: "#FFC233"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M172.007 131.742C172.114 133.449 171.782 135.155 171.041 136.697C154.054 143.891 134.927 144.13 117.766 137.361C107.932 116.276 165.068 106.307 172.007 131.742Z",
    fill: "#5E3911"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.538 20.7563L109.862 132.83L108.535 131.803L141.538 14.2917V20.7563Z",
    fill: "#F25C3E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180.27 131.38L178.943 132.286L142.562 20.6959V15.0167L142.924 16.3459L180.27 131.38Z",
    fill: "#F25C3E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.114 78.0317L136.167 12.9022V3.17505L235.114 50.8441V78.0317Z",
    fill: "#5E3911"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M247 46.2523L235.114 50.844L136.167 3.17501L139.847 1L247 46.2523Z",
    fill: "#E29F00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M226.306 250.764C258.645 243.695 294.604 253.785 306.55 273.36C318.496 292.935 301.964 314.504 269.565 321.694C237.166 328.883 201.267 318.673 189.321 299.158C177.375 279.643 193.907 257.893 226.306 250.764Z",
    fill: "#FFC233"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M217.861 258.135C217.861 258.135 263.714 250.401 277.471 257.712C279.933 259.495 281.736 262.044 282.599 264.962C282.897 268.438 282.133 271.922 280.409 274.954C278.686 277.986 276.083 280.422 272.946 281.939C265.239 285.841 256.724 287.875 248.088 287.875C239.452 287.875 230.937 285.841 223.231 281.939C215.749 277.589 212.008 271.849 212.974 266.774C213.713 263.474 215.414 260.467 217.861 258.135Z",
    fill: "#E29F00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M225.099 251.67C232.199 248.08 240.042 246.21 247.995 246.21C255.949 246.21 263.792 248.08 270.892 251.67C283.562 258.981 283.622 270.822 270.892 278.133C263.796 281.737 255.952 283.615 247.995 283.615C240.039 283.615 232.195 281.737 225.099 278.133C212.549 270.822 212.489 258.981 225.099 251.67Z",
    fill: "#FFD471"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M259.43 263.331C259.383 264.405 259.051 265.447 258.468 266.35C257.885 267.253 257.071 267.983 256.112 268.466C253.601 269.721 250.833 270.375 248.027 270.375C245.221 270.375 242.453 269.721 239.942 268.466C238.972 268.065 238.141 267.387 237.551 266.517C236.961 265.647 236.639 264.624 236.624 263.572V51.6295H259.43V263.331Z",
    fill: "#FFC233"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M257.739 34.1086C262.432 36.5826 266.274 40.4102 268.77 45.0959C271.266 49.7816 272.299 55.1095 271.737 60.39L269.203 83.7109C269.23 84.2697 269.111 84.8258 268.857 85.324C268.603 85.8223 268.223 86.2451 267.755 86.5505L266.85 86.913L247.181 97.6673L225.4 38.0961L233.123 34.0482C236.925 32.0622 241.151 31.0302 245.439 31.0407C249.726 31.0513 253.947 32.104 257.739 34.1086Z",
    fill: "#FFD471"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M230.59 38.8815L242.958 46.0711C245.425 47.6602 247.456 49.8408 248.868 52.4151C250.279 54.9894 251.027 57.8759 251.043 60.8128L248.448 94.7068C248.448 97.7276 245.975 98.8151 243.26 97.2443L230.288 89.7526C228.845 88.8087 227.63 87.5542 226.732 86.0804C225.835 84.6067 225.277 82.9509 225.099 81.2338L222.565 44.319C222.143 38.6398 225.823 36.1627 230.59 38.8815Z",
    fill: "#976A00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M273.849 63.1691L375.873 133.374L372.193 135.549L256.231 61.7191C259.047 60.4324 262.145 59.8901 265.229 60.144C268.313 60.3978 271.281 61.4394 273.849 63.1691Z",
    fill: "#E29F00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M256.232 61.7191L372.193 135.549L368.452 141.59L265.101 92.713C261.778 91.1564 259.019 88.6065 257.204 85.4146C255.389 82.2227 254.606 78.5457 254.965 74.89L256.232 61.7191Z",
    fill: "#5E3911"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M375.934 133.253L372.917 139.415L368.452 141.772L372.193 135.488L375.934 133.253Z",
    fill: "#F5AC00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_734_22644",
    x1: 196.018,
    y1: 212.339,
    x2: 329.111,
    y2: 340.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCFD4",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888A8C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadSectionImage);
export default __webpack_public_path__ + "static/media/headSectionImage.09a76c88bb304ec723bb1afc7ddb031f.svg";
export { ForwardRef as ReactComponent };